import { AdministeredOrganization } from '../loggedinweb-generated';
import { useState, useMemo } from 'react';

const mapToOrganizationDetails = (item: AdministeredOrganization) => ({
	key: item.Key,
	name: item.Name,
	logoUrl: item.LogoUrl,
	url: item.Url,
});

export function useMyOrganizations(administeredOrgs: AdministeredOrganization[], currentOrg: AdministeredOrganization) {
	const [organizations, setOrganizations] = useState(() => administeredOrgs.map(mapToOrganizationDetails));
	const currentOrganization = useMemo(() => mapToOrganizationDetails(currentOrg), [currentOrg]);

	return {
		currentOrganization,
		organizations,
		setOrganizations,
	};
}
